import { FunctionComponent, PropsWithChildren } from 'react';

import { useGetApkPlatforms } from '../../hooks/use-get-apk-platforms';
import { ApkPlatformsDropdownProps } from '../../types/apk-platforms-dropdown-props.type';

const withApkPlatformsOptions = (
  Component: FunctionComponent<ApkPlatformsDropdownProps>
): FunctionComponent<ApkPlatformsDropdownProps> => {
  return (props: PropsWithChildren<ApkPlatformsDropdownProps>) => {
    const platforms = useGetApkPlatforms(
      props.exceptedAppReleasesFormStateFields?.platforms ?? []
    );
    return <Component {...props} options={platforms} />;
  };
};

export default withApkPlatformsOptions;
